import { useEffect, useRef } from 'react'

import { Message } from './components'

import styles from './chat.module.css'
import type { ChatProps } from './chat.type'

export const Chat = ({
  messages,
  isLoading,
}: ChatProps) => {

  const contentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTo({
        top: contentRef.current.scrollHeight,
        behavior: 'smooth',
      })
    }
  }, [messages])



  return (
    <div className={styles.core}>
      <div className={styles.content} ref={contentRef}>
        {messages?.map((message, index) => (
          <Message {...message} isLoading={false} key={index} />
        ))}

        {isLoading && (
          <Message isFromHost content="Loading..." isLoading={true} />
        )}
      </div>

    </div>
  )
}
